<?xml version="1.0" encoding="utf-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="business-activity" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
     y="0px"
     viewBox="0 4 30 21" enable-background="new 0 0 30 30" xml:space="preserve">
<g>
	<path fill="currentColor" d="M13,26c0,0-0.1,0-0.1,0c-0.5-0.1-0.8-0.4-0.9-0.9l-0.7-10.8l-1.4,3.2C9.8,17.8,9.4,18,9,18l-8-2h7.3
		l2.7-6.4c0.2-0.4,0.6-0.7,1.1-0.6C12.6,9.1,13,9.5,13,9.9l0.7,10.1l5.4-15.4c0.2-0.5,0.6-0.8,1.1-0.7C20.6,4.1,21,4.5,21,5v13.4
		l1.1-1.9c0.2-0.3,0.5-0.5,0.9-0.5h5c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4.4l-2.7,4.5c-0.2,0.4-0.7,0.6-1.1,0.4c-0.4-0.1-0.7-0.5-0.7-1
		V10.9l-5.1,14.4C13.8,25.7,13.4,26,13,26z"/>
</g>
</svg>
